// extracted by mini-css-extract-plugin
export default {"productGallery":"IH-z","inQuickShop":"JH-z"};